'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/loadBalance/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "load balance" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/loadBalance/StaticView#model
   * @type {actions/loadBalance/EditLoadBalance}
   */

  template: twig({data: tpl}),
});
